import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';

interface IProps {
    currentStep: number;
    messages: {
        email: string;
        password: string;
        password_confirm: string;
    };
}

export const forgotPasswordValidation = ({ messages, currentStep }: IProps) => {
    const steps = [
        z.object({
            email: validator.email(messages.email)
        }),
        z
            .object({
                password: validator.password(messages.password),
                password_confirm: validator.password(messages.password)
            })
            .refine((data) => data.password === data.password_confirm, {
                message: messages.password_confirm,
                path: ['password_confirm']
            })
    ];

    return steps[currentStep];
};
